import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type Hashtag = {
  id: string
  name: string
  contactAccountIds?: string[]
}

const fetchHashtags = async ({ pageParam = '0', q }: FetchParams): Promise<PaginatedResponse<Hashtag>> => {
  const params = new URLSearchParams()
  params.append('page', pageParam)
  if (q) {
    params.append('q', q)
  }
  const url = `/hashtags?${params.toString()}`
  const { data } = await api.get<PaginatedResponse<Hashtag>>(url)
  return data
}

export const usePaginateHashtags = (q?: string) => {
  return usePaginate<Hashtag>('hashtags', fetchHashtags, { q })
}

